module.exports = __webpack_public_path__ + "img/pistol.semiauto.f259914b.png";